import { createAction } from "@reduxjs/toolkit"

export const getChartSignInAsync = createAction(
   "chartSignIn/getChartSignInDataAsync"
)

export const exportExcelChartSignInAsync = createAction<any>(
   "chartSignIn/exportExcelChartSignInAsync"
)
